export default __webpack_public_path__ + "static/media/YOOZ-WEBSITE-COLLECT-DONATIONS-banner.8f48e846.png";